import ReactDOM from 'react-dom';

/**
 * For use in dropdown-like components, where extra content appears when you click on them.
 * If you click away from the component, the content will be hidden.
 *
 * This code was adapted from https://github.com/Pomax/react-onclickoutside, which is MIT licensed.
 */
var registeredComponents = [];
var handlers = [];
var IGNORE_CLASS = 'ignore-react-onclickoutside';

export const DropdownMixin = {
    getInitialState: function () {
        return {
            isOpen: false,
        };
    },

    /**
     * @param handler Function that will be executed whenever the user clicks outside this element
     */
    registerClickOutsideHandler: function (handler) {
        var fn = (function (localNode, eventHandler) {
            return function (evt) {
                var source = evt.target;
                var found = false;
                // If source=local then this event came from "somewhere"
                // inside and should be ignored. We could handle this with
                // a layered approach, too, but that requires going back to
                // thinking in terms of Dom node nesting, running counter
                // to React's "you shouldn't care about the DOM" philosophy.
                while (source.parentNode) {
                    found = (source === localNode || source.classList.contains(IGNORE_CLASS));
                    if (found) return;
                    source = source.parentNode;
                }
                eventHandler(evt);
            };
        // TODO we should replace this DOM lookup with refs. Not exactly sure the best way to handle this with a mix-in
        // eslint-disable-next-line react/no-find-dom-node
        }(ReactDOM.findDOMNode(this), handler));

        document.addEventListener('mousedown', fn);
        document.addEventListener('touchstart', fn);

        var pos = registeredComponents.length;
        registeredComponents.push(this);
        handlers[pos] = fn;
    },

    // componentDidMount and componentWillUnmount come from https://github.com/Pomax/react-onclickoutside
    componentDidMount: function () {
        this.registerClickOutsideHandler(this.close);
    },

    componentWillUnmount: function () {
        var pos = registeredComponents.indexOf(this);
        while (pos > -1) {
            var fn = handlers[pos];

            if (fn) {
                // clean up so we don't leak memory
                handlers.splice(pos, 1);
                registeredComponents.splice(pos, 1);
                document.removeEventListener('mousedown', fn);
                document.removeEventListener('touchstart', fn);

                pos = registeredComponents.indexOf(this);
            } else {
                break;
            }
        }
    },

    toggleOpen: function (open) {
        this.setState({
            isOpen: (typeof open === 'boolean') ? open : !this.state.isOpen,
        });
    },

    close: function () {
        this.setState({ isOpen: false });
    },

    UNSAFE_componentWillReceiveProps: function (newProps) {
        this.close();
    },
};
